/*
 * Copyright (c) 2017 Ytica.com a.s. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import initRouter from './router'
// Material components
import Vuetify from 'vuetify'
import theme from '@ytica/vuetify-theme'
// Axios (ajax)
import axios from 'axios'
import VueAxios from 'vue-axios'

import VueIntercom from 'vue-intercom'

// Identity lib
import YticaIdentityClientVue from '@ytica/ytica-identity-client-vue'
// env-config file
import * as ENV from '../ext/env-config'

axios.defaults.headers.common.Accept = 'application/json'

Vue.use(VueAxios, axios)

Vue.use(Vuetify, {
  theme: {
    ...theme.default
  }
})

Vue.use(VueIntercom, { appId: 'ddwbtdib' })

Vue.config.productionTip = false

Vue.config.BASE_URL = ENV.BASE_URL
Vue.config.SSO_URL = ENV.SSO_URL
Vue.config.SSO_API_URL = ENV.SSO_API_URL

axios.defaults.baseURL = Vue.config.SSO_API_URL
axios.defaults.headers.common.Accept = 'application/json'

//  init Router
const router = initRouter(Vue.config.BASE_URL || '/')

Vue.use(YticaIdentityClientVue, {
  axios: axios,
  router: router,
  url: Vue.config.SSO_API_URL,
  urlBase: Vue.config.SSO_URL
})

Vue.router = router

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js